export enum ATHDirectionOfTransactionEnum {
  Incoming = 1,
  Outgoing
}

export namespace ATHDirectionOfTransactionEnum {
  export function values() {
    return Object.keys(ATHDirectionOfTransactionEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
